import React from 'react';
import style from './block.module.scss';
import { BlockWrapper, defineBlock, smartProps } from '@smartfire/js-block-engine';
import { EditableText } from '@smartfire/components';

function Block() {
    return (
        <BlockWrapper.Div className={style.block}>
            <div className={style.content}>
                <EditableText
                    tagName="p"
                    placeholder="ajouter un texte"
                    smartProp="text"
                    allowedFormats={['core/bold', 'advanced/color', 'core/link']}
                />
            </div>
        </BlockWrapper.Div>
    );
}

export default defineBlock({
    Block,
    smartProps: {
        text: smartProps.string.withDefault(''),
    },
    setup: {
        title: 'Encart gris',
        icon: 'align-center',
    },
});
